var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 553,
    viewBox: "0 0 496 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.221 187.53L199.287 18.3391C192.582 6.90193 180.553 0 167.342 0H37.3918C8.79892 0 -9.14558 30.7622 4.85507 55.6084C30.8845 101.554 67.5622 140.795 111.93 169.585C126.917 181.22 145.453 187.53 164.581 187.53H302.221Z",
    fill: "#0074BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.804 0H327.855C314.643 0 302.614 6.90193 295.909 18.3391L192.975 187.53H330.812C349.94 187.53 368.279 181.22 383.463 169.585C427.831 140.795 464.509 101.751 490.538 55.6084C504.342 30.7622 486.397 0 457.804 0Z",
    fill: "#00A6ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.444 552.136C356.785 552.136 445.425 461.29 445.425 349.226C445.425 237.161 356.785 146.315 247.444 146.315C138.1 146.315 49.4619 237.161 49.4619 349.226C49.4619 461.29 138.1 552.136 247.444 552.136Z",
    fill: "#FFB02E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.643 527.684C201.106 527.684 157.329 509.148 124.596 475.428C91.6651 441.709 73.5234 396.946 73.5234 349.225C73.5234 301.505 91.6651 256.742 124.596 223.022C192.43 153.412 302.857 153.412 370.889 223.022C438.723 292.631 438.723 405.82 370.889 475.428C337.76 509.148 293.984 527.684 247.643 527.684ZM247.446 195.021C208.994 195.021 170.344 210.008 141.16 240.178C112.765 269.362 97.1865 308.012 97.1865 349.225C97.1865 390.439 112.765 429.088 141.16 458.273C169.555 487.457 207.416 503.43 247.446 503.43C287.673 503.43 325.337 487.457 353.733 458.273C412.299 398.129 412.299 300.322 353.733 240.178C324.548 210.008 286.096 195.021 247.446 195.021Z",
    fill: "#FCD53F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.162 271.234V414.221H233.106V271.234H263.162Z",
    fill: "#6D4534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1St);
export default __webpack_public_path__ + "static/media/1st.5e905b97a1f01f66645595c1859cedc8.svg";
export { ForwardRef as ReactComponent };